(() => {
  const ROOT = document.documentElement;
  const ACTIVE_CLASS = 'ab-fuel-31-b';
  const FOOTER_SELECTOR = '.rebuy-cart__flyout-footer';
  const CHECKOUT_BTN_SELECTOR = '.rebuy-button.rebuy-cart__checkout-button.block';
  const DRAWER_FOOTER_SELECTOR = '.cart-drawer__checkout-buttons';
  const DRAWER_CHECKOUT_SELECTOR = '[name="checkout"]';
  const INJECTED_MARKER = 'data-quick-buy-option-injected';
  const WRAP_CLASS = 'quick-buy-option quick-buy-option--b';

  let cachedCartEl = null;
  let cartFetch = null;
  // /cart only renders wallet buttons for a non-empty cart, so fetch after the
  // cart is opened or changed, and retry only on the next such event.
  let fetchAllowed = false;

  const isActive = () => ROOT.classList.contains(ACTIVE_CLASS) || Boolean(window.Shopify?.designMode);

  const copyCartElement = (tpl) => {
    const el = document.createElement('shopify-accelerated-checkout-cart');
    tpl.getAttributeNames().forEach((name) => {
      el.setAttribute(name, tpl.getAttribute(name));
    });
    return el;
  };

  const findHydratedCart = (root = document) =>
    root.querySelector('shopify-accelerated-checkout-cart[wallet-configs]');

  const loadCartElement = () => {
    if (cachedCartEl) return Promise.resolve(cachedCartEl);

    const existing = findHydratedCart();
    if (existing) {
      cachedCartEl = existing;
      return Promise.resolve(existing);
    }

    if (cartFetch) return cartFetch;

    fetchAllowed = false;
    cartFetch = fetch(`${window.Shopify?.routes?.root || '/'}cart`)
      .then((response) => response.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        cachedCartEl = findHydratedCart(doc);
        return cachedCartEl;
      })
      .catch(() => null)
      .finally(() => {
        cartFetch = null;
      });

    return cartFetch;
  };

  const mountInto = (footer, anchor) => {
    if (!footer || !anchor || footer.hasAttribute(INJECTED_MARKER)) return;
    if (!cachedCartEl && !cartFetch && !fetchAllowed && !findHydratedCart()) return;

    // Route mounts its checkout right after the anchor; keep wallets below it.
    const next = anchor.nextElementSibling;
    const after = next?.matches('[data-route-widget]') ? next : anchor;

    const wrap = document.createElement('div');
    wrap.className = WRAP_CLASS;
    after.insertAdjacentElement('afterend', wrap);
    footer.setAttribute(INJECTED_MARKER, '');

    loadCartElement().then((tpl) => {
      if (tpl) {
        if (!wrap.querySelector('shopify-accelerated-checkout-cart')) wrap.appendChild(copyCartElement(tpl));
        return;
      }
      wrap.remove();
      footer.removeAttribute(INJECTED_MARKER);
    });
  };

  const inject = () => {
    const rebuyFooter = document.querySelector(FOOTER_SELECTOR);
    mountInto(rebuyFooter, rebuyFooter?.querySelector(CHECKOUT_BTN_SELECTOR));

    const drawerFooter = document.querySelector(DRAWER_FOOTER_SELECTOR);
    mountInto(drawerFooter, drawerFooter?.querySelector(DRAWER_CHECKOUT_SELECTOR));
  };

  const onCartShow = () => {
    fetchAllowed = true;
    inject();
  };

  // Rebuy also fires cart.change on init; only fetch while the cart is open.
  const onCartChange = () => {
    if (document.querySelector('#rebuy-cart.is-visible')) fetchAllowed = true;
    inject();
  };

  const start = () => {
    inject();
    const observer = new MutationObserver(() => {
      if (document.querySelector(FOOTER_SELECTOR) || document.querySelector(DRAWER_FOOTER_SELECTOR)) inject();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    document.addEventListener('rebuy:smartcart.show', onCartShow);
    document.addEventListener('rebuy:cart.change', onCartChange);
    document.addEventListener('rebuy.cart.change', onCartChange);
  };

  const init = () => {
    if (isActive()) {
      start();
      return;
    }

    // The testing tool can assign the class after this script runs.
    const classObserver = new MutationObserver(() => {
      if (!isActive()) return;
      classObserver.disconnect();
      start();
    });
    classObserver.observe(ROOT, { attributes: true, attributeFilter: ['class'] });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
